import { render } from "./Cog.vue?vue&type=template&id=e06385a2"
import script from "./Cog.vue?vue&type=script&lang=js"
export * from "./Cog.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Cog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e06385a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e06385a2', __exports__)) {
    api.reload('e06385a2', __exports__)
  }
  
  module.hot.accept("./Cog.vue?vue&type=template&id=e06385a2", () => {
    api.rerender('e06385a2', render)
  })

}


export default __exports__